// Utils
import { DEV } from "utils/urlUtils";

export const appPackageName = DEV ? "app-dev.sandboxx.us" : "app.sandboxx.us";
export const iterableApiKey = DEV
    ? process.env.REACT_APP_ITERABLE_API_KEY_DEV
    : process.env.REACT_APP_ITERABLE_API_KEY_PROD;
